import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// Loads the V5 dashboard from existing, org-scoped endpoints only (no new backend).
export const nzToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Pacific/Auckland" }).format(new Date());

const SOURCES = (today) => ({
  stats: ["/stats"],
  panel: ["/overview/panel"],
  jobs: ["/jobs"],
  users: ["/users"],
  fleet: ["/fleet"],
  timesheets: ["/timesheets/page", { params: { start: today, end: today, page_size: 1 } }],
  assignments: ["/assignments", { params: { date: today } }],
  dispatch: ["/dispatch", { params: { date: today } }],
});

export function useDashboardV5() {
  const [state, setState] = useState({ loading: true, data: {}, failed: [] });
  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true }));
    const entries = Object.entries(SOURCES(nzToday()));
    const res = await Promise.allSettled(entries.map(([, [url, cfg]]) => api.get(url, cfg)));
    const data = {}; const failed = [];
    res.forEach((r, i) => {
      const key = entries[i][0];
      if (r.status === "fulfilled") data[key] = r.value.data;
      else failed.push(key);
    });
    setState({ loading: false, data, failed });
  }, []);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}

export const initials = (name = "") => name.split(" ").filter(Boolean).map((p) => p[0]).join("").slice(0, 2).toUpperCase() || "?";
export const money = (n) => new Intl.NumberFormat("en-NZ", { style: "currency", currency: "NZD", maximumFractionDigits: 0 }).format(n || 0);
export const pct = (a, b) => (b > 0 ? Math.max(0, Math.min(100, Math.round((a / b) * 100))) : 0);
